
<template>
  <div class="d-flex justify-content-center table-icon">
    <i class="mdi mdi-qrcode" @click="modalShow = !modalShow"></i>
    <b-modal v-model="modalShow" ok-title="save" centered hide-footer>
      <div class="d-flex flex-column align-items-center">
        <qrcode-vue ref="qrcode" :value="link" :size="200" render-as="canvas" />
        <b-button class="mt-3" @click="downloadQR">Download</b-button>
      </div>
    </b-modal>
  </div>
</template>


<script>
import QrcodeVue from 'qrcode.vue';
export default {
  components: { QrcodeVue },
  props: {
    link: {
      type: String,
      default: 'https://example.com',
    },
  },
  data() {
    return {
      modalShow: false,
    };
  },

  methods: {
    downloadQR() {
      const canvas = this.$refs.qrcode.$el.querySelector('canvas');
      const link = document.createElement('a');
      link.href = canvas.toDataURL('image/png');
      link.download = 'qrcode.png';
      link.click();
    },
  },
};
</script>

<style lang="scss" scoped>
i {
  font-size: 40px;
  margin-top: 10px;
}
</style>